import type { JSX } from "react"
import type { TitleAppProps, TitleProps } from "./title.props"

export function Title({ title, typeTitle }: Readonly<TitleProps>) {
    const Tag = typeTitle as keyof JSX.IntrinsicElements
    
    return (
        <Tag dangerouslySetInnerHTML={{ __html: title }} />
    )
}

export default class TitleApp {
    constructor({ id, title, typeTitle }: TitleAppProps) {
        const el = document.getElementById(id)
        if (!el) return

        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<Title title={title} typeTitle={typeTitle} />)
    }
}
